import React, { useState, useContext } from 'react'
import * as AuthAPI from '../services/authAPI';
import AuthContext from '../context/AuthContext';
import Field from '../components/Field';

export default function LoginPage({ navigate }) {

        const { setIsAuthenticated } = useContext(AuthContext);

        const [credentials, setCredentials] = useState({
                email: "",
                password: ""
        });

        const [error, setError] = useState("");

        const handleChange = ({ currentTarget }) => {
                const { value, name } = currentTarget;
                setCredentials({...credentials, [name]: value});
        };

        const handleSubmit = async event => {
            event.preventDefault();
            try {
                    await AuthAPI.authenticate(credentials);
                    setError("");
                    setIsAuthenticated(true);
                    navigate("/label", { replace: true });
            } catch (error) {
                    console.log(error);
                    setCredentials({email: "", password: ""});
                    setError("E-mail ou mot de pase incorrect");
            }
        }

    return (
        <>
			<section className="vh-100">
				<div className="container py-5 h-100">
					<div className="row d-flex justify-content-center align-items-center h-100">
					<div className="col-12 col-md-8 col-lg-6 col-xl-5">
						<div className="card shadow-2-strong">
						<div className="card-body p-5 text-center">


							<h3 className="mb-5">Connexion</h3>
									<Field 
										name="email"
										label="Adresse électronique"
										value={credentials.email}
										onChange={handleChange}
										type="email"
										error={error}
									/>
									<Field
										name="password"
										label="Mot de passe"
										value={credentials.password}
										onChange={handleChange}
										type="password"
										error={error}
									/>
									{error && <p className="text-danger text-center">{error}</p>}
									<div className="row">
										<button onClick={handleSubmit} className="col-md btn btn-primary">Connexion</button>
									</div>
						</div>
						</div>
					</div>
					</div>
				</div>
			</section>
        </>
    )
}